import React from "react";
import { inject, observer } from "mobx-react";
import moment from "moment";
import agent from "../../../agent";
import GameApplyInfo from "./gameApplyInfo";
import { $util } from "../../../helper";

@inject("gameStore", "teamStore", "languageStore")
@observer
export default class GameApply extends React.Component {
  state = {
    finish: false,
    showCollectionStage: false,
    strategyId: void 0
  };

  componentWillMount() {
    // 防止</GameInfo>里的组件重复渲染，每次进来前清空数据
    this.props.teamStore.resetTeamInfo();
    this.props.teamStore.resetQuiz();
    this.props.teamStore.resetStageMap();
  }

  componentWillUnmount() {
    this.intervalTag && clearInterval(this.intervalTag);
    this.props.teamStore.resetCollectionInfoData();
  }

  async componentDidMount() {
    if (!this.props.match.params.id) {
      this.props.history.push("/control-center");
      return;
    }
    if (this.props.gameStore.showTeamSloganGameCategoryId.length < 1) {
      await this.props.gameStore.getV2AllCategory();
    }
    if (Object.keys(this.props.teamStore.teamInfo).length < 1) {
      await this.props.teamStore.getTeamInfo(this.props.match.params.id);
    }
    this.props.teamStore.resetCollectionInfoData();
    const isSpecialGame = await this.judgeIsSpecialGame();
    this.props.teamStore.setCurrentTeamIsSpecialGame(isSpecialGame);
    await this.getSubmissionRulesFromServer();
    this.setState({
      finish: true
    });
    this.intervalTag = setInterval(this.getSubmissionRulesFromServer, 10 * 1000);
  }

  judgeTimeIsOk = (ddlTime, curTime) => {
    return moment(ddlTime).isAfter(moment(curTime));
  };

  // 获取当前赛事当前流程环节是否有名单收集
  getSubmissionRulesFromServer = async () => {
    try {
      const curFlowInfo = this.props.teamStore.teamInfo.myFlow;
      const curStageId = this.props.teamStore.teamInfo.stageId;
      const resp = await agent.SassPlatform.getCollectionListInfo(
        curFlowInfo.eventId,
        this.props.match.params.id
      );
      if (
        resp &&
        resp.timestamp &&
        resp.success &&
        Array.isArray(resp.data) &&
        resp.data.length > 0
      ) {
        const curFlowConfig = resp.data.find(item => +item.flowId === +curFlowInfo.id);
        if (
          curFlowConfig &&
          Array.isArray(curFlowConfig.stages) &&
          curFlowConfig.stages.length > 0
        ) {
          let tag = true,
            index = 0;
          while (tag) {
            // 对于同一个流程下的同一个环节，可能会发起多次名单收集，所以需要逐个判断当前处于那个名单收集阶段。
            index >= curFlowConfig.stages.length && (tag = false);
            const curStageConfig = curFlowConfig.stages[index];
            if (
              curStageConfig &&
              +curStageConfig.stageId === +curStageId &&
              curStageConfig.collectionId &&
              curStageConfig.strategyId &&
              // 这里使用服务端时间判断
              this.judgeTimeIsOk(curStageConfig.ddlTime, resp.timestamp)
            ) {
              // 获取当前战队在收集战队参赛名单阶段的状态
              const resState = await agent.SassPlatform.getCollectionProcessState(
                this.props.match.params.id,
                curStageConfig.collectionId
              );
              if (resState.success && resState.data) {
                if (!resState.data.confirmTeamInfo) {
                  // 还在确认参赛信息阶段
                  this.props.teamStore.setShowCollectionState(true);
                  this.props.teamStore.setCollectionStrategyId(curStageConfig.collectionId);
                  this.props.teamStore.setCollectionId(curStageConfig.collectionId);
                  tag = false;
                } else if (
                  resState.data.confirmTeamInfo &&
                  (!resState.data.submitPreEntryList || !resState.data.submitEntryList)
                ) {
                  // 在提交参赛名单阶段，需要跳转
                  $util.openTeamSubmitEntryListPage({
                    teamId: this.props.match.params.id,
                    lang: this.props.languageStore.lang,
                    bbsTeamId: this.props.teamStore.teamInfo.bbsTeamId,
                    eventId: curFlowInfo.eventId,
                    collectionId: curStageConfig.collectionId
                  });
                  tag = false;
                }
              }
            }
            index++;
          }
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  judgeIsSpecialGame = async () => {
    if (
      this.props.teamStore.teamInfo &&
      this.props.teamStore.teamInfo.gevent &&
      this.props.gameStore.showTeamSloganGameCategoryId &&
      this.props.gameStore.showTeamSloganGameCategoryId.length > 0
    ) {
      const eventIdOfTeam = this.props.teamStore.teamInfo.gevent.id;

      const lang = this.props.languageStore.lang;

      for (let categoryId of this.props.gameStore.showTeamSloganGameCategoryId) {
        let whileIsOk = true;
        let pageNum = 1;
        while (whileIsOk) {
          try {
            const res = await agent.Games.getV2Events(
              $util.beLangMap(lang),
              pageNum,
              50,
              categoryId
            );
            if (res && res.data && res.data.events && res.data.events.length > 0) {
              const targetGame = res.data.events.find(item => item.id === `${eventIdOfTeam}`);
              if (targetGame) {
                return true;
              }
              whileIsOk = !(targetGame || res.data.total_pages === res.data.current_page);
              pageNum++;
            } else {
              whileIsOk = false;
            }
          } catch (error) {
            whileIsOk = false;
            console.error(error);
          }
        }
      }
    }
    return false;
  };

  render() {
    if (!this.state.finish) return null;
    return (
      <GameApplyInfo
        allInfoIsLegal={this.props.teamStore.allInfoIsLegal}
        gameRegistrationModal={this.props.gameStore.gameRegistrationModal}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/controlCenter/gameApply/index.js